import { queryOptions } from "@tanstack/react-query";
import { authenticatedRequest } from "@/lib/graphql/client";
import {
  ADMIN_SURVEY_STATS,
  ADMIN_SURVEY_RESPONSES,
} from "@/lib/graphql/queries/survey";
import type {
  AdminSurveyStats,
  AdminSurveyResponsesResponse,
} from "@/types/survey";

export const surveyKeys = {
  all: ["survey"] as const,
  stats: () => [...surveyKeys.all, "stats"] as const,
  responses: () => [...surveyKeys.all, "responses"] as const,
  responseList: (pagination: { page: number; limit: number }) =>
    [...surveyKeys.responses(), pagination] as const,
};

export function surveyStatsQueryOptions() {
  return queryOptions({
    queryKey: surveyKeys.stats(),
    queryFn: async () => {
      const data = await authenticatedRequest<{
        adminSurveyStats: AdminSurveyStats;
      }>(ADMIN_SURVEY_STATS);

      return data.adminSurveyStats;
    },
    staleTime: 60000,
  });
}

export function surveyResponsesQueryOptions(pagination: {
  page: number;
  limit: number;
}) {
  return queryOptions({
    queryKey: surveyKeys.responseList(pagination),
    queryFn: async () => {
      const data = await authenticatedRequest<{
        adminSurveyResponses: AdminSurveyResponsesResponse;
      }>(ADMIN_SURVEY_RESPONSES, {
        input: { page: pagination.page, limit: pagination.limit },
      });

      return data.adminSurveyResponses;
    },
    placeholderData: (prev) => prev,
    staleTime: 30000,
  });
}
